module.exports = __webpack_public_path__ + "img/pbg.543de3bd.png";